import { render, staticRenderFns } from "./prontuarios_agenda.vue?vue&type=template&id=a6e39534"
import script from "./prontuarios_agenda.vue?vue&type=script&lang=js"
export * from "./prontuarios_agenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports